import React from 'react';
import Typography from '@mui/material/Typography'; // MUI Typography import

function CSMSHealth() {
    return (
        <div>
            <Typography variant="body1">CSMSHealth</Typography>
        </div>
    );
}

export default CSMSHealth;